import React from 'react';

const Health = () => {
  const healthServices = [
    {
      id: 1,
      title: "Regular Health Checkups",
      description: "Comprehensive health examinations for early detection",
      icon: "🩺",
      features: ["Physical examination", "Weight monitoring", "Dental checkup", "Vaccination updates"]
    },
    {
      id: 2,
      title: "Emergency Care",
      description: "24/7 emergency veterinary services",
      icon: "🚑",
      features: ["24/7 availability", "Critical care", "Surgery", "Trauma treatment"]
    },
    {
      id: 3,
      title: "Vaccination Programs",
      description: "Complete vaccination schedules for all life stages",
      icon: "💉",
      features: ["Puppy vaccines", "Annual boosters", "Travel vaccines", "Disease prevention"]
    },
    {
      id: 4,
      title: "Nutrition Counseling",
      description: "Expert guidance on optimal pet nutrition",
      icon: "🥗",
      features: ["Diet planning", "Weight management", "Special needs", "Supplement advice"]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="container mx-auto px-4 py-12">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pet Health & Wellness
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Comprehensive healthcare services to keep your pets healthy and happy throughout their lives
          </p>
        </div>

        {/* Health Services */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {healthServices.map((service) => (
            <div key={service.id} className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-shadow">
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-2xl font-semibold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, index) => (
                  <li key={index} className="flex items-center text-gray-700">
                    <span className="text-[#FF5E4C] mr-2">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className="mt-6 bg-[#FF5E4C] text-white px-6 py-3 rounded-lg hover:bg-[#E55347] transition-colors font-semibold w-full">
                Learn More
              </button>
            </div>
          ))}
        </div>

        {/* Health Tips Section */}
        <div className="bg-white rounded-xl p-8 shadow-lg mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Essential Health Tips
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-3xl mb-3">🦷</div>
              <h3 className="text-lg font-semibold mb-2">Dental Care</h3>
              <p className="text-gray-600">Regular brushing and dental treats help maintain oral health</p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-3">🏃‍♂️</div>
              <h3 className="text-lg font-semibold mb-2">Exercise</h3>
              <p className="text-gray-600">Daily exercise keeps pets physically and mentally healthy</p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-3">💧</div>
              <h3 className="text-lg font-semibold mb-2">Hydration</h3>
              <p className="text-gray-600">Fresh water should always be available for your pets</p>
            </div>
          </div>
        </div>

        {/* Emergency Contact */}
        <div className="bg-red-50 border-l-4 border-red-400 p-6 rounded-lg">
          <div className="flex items-center">
            <div className="text-red-400 text-2xl mr-4">🚨</div>
            <div>
              <h3 className="text-lg font-semibold text-red-800">Emergency Helpline</h3>
              <p className="text-red-700">For pet emergencies, call us immediately at <strong>1800-PET-HELP</strong></p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Health; 